var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.47,
    d: "M11.25 2H14.25C14.4489 2 14.6397 2.07902 14.7803 2.21967C14.921 2.36032 15 2.55109 15 2.75V14.75C15 14.9489 14.921 15.1397 14.7803 15.2803C14.6397 15.421 14.4489 15.5 14.25 15.5H0.75C0.551088 15.5 0.360322 15.421 0.21967 15.2803C0.0790176 15.1397 0 14.9489 0 14.75V2.75C0 2.55109 0.0790176 2.36032 0.21967 2.21967C0.360322 2.07902 0.551088 2 0.75 2H3.75V0.5H5.25V2H9.75V0.5H11.25V2ZM9.75 3.5H5.25V5H3.75V3.5H1.5V6.5H13.5V3.5H11.25V5H9.75V3.5ZM13.5 8H1.5V14H13.5V8Z",
    fill: "#63658E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1249ed95dddce2cef23491edc24b8e9b.svg";
export { ForwardRef as ReactComponent };